
export function getCompanyFromSubdomain(companies) {
    const [subdomain] = window.location.host.split('.');

    return companies.find(c => c.subdomain === subdomain);
}

export function getSingleCompanyId(companies) {
    return getCompanyFromSubdomain(companies)?._id ?? companies[0]?._id;
}